import Presenter from './Presenter';
import { IContainerProps } from './types';

const ItemPillContainer = (props: IContainerProps) => {

    return (
        <Presenter {...props} />
    );
};

export default ItemPillContainer;
